






















































import {
  computed, defineComponent, PropType,
} from '@vue/composition-api'
import { useVModel } from '@vueuse/core'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'
import { UserAttrs } from '@/api/v2/report/Aggregation'
import { AggregationUserAttrs } from '@/api/v2/report/AggregationUser'
import { useAggregationType } from '../composables/useAggregationType'
import { DisplayMode } from '@/views/v2-temp/report/aggregation-container/composables/useAggregationResultTable'
import GroupedCombobox from '@/views/v2-temp/common/components/GroupedCombobox.vue'

export default defineComponent({
  name: 'AggregationTableFilters',
  components: {
    GroupedCombobox,
  },
  props: {
    aggregation: {
      type: Object as PropType<AggregationResultAttributes>,
      required: true,
    },
    displayMode: {
      type: String as PropType<DisplayMode>,
      required: true,
    },
    selectedUserId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    aggregationUsers: {
      type: Array as PropType<AggregationUserAttrs[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const displayModeModel = useVModel(props, 'displayMode', emit)
    const selectedUserIdModel = useVModel(props, 'selectedUserId', emit)

    const selectedUser = computed({
      get: () => props.aggregationUsers.find(au => au.user.data.attributes.id === selectedUserIdModel.value)?.user.data.attributes || null,
      set: (value: UserAttrs | null) => {
        selectedUserIdModel.value = value?.id || null
      },
    })

    const { isUserAggregation } = useAggregationType(props.aggregation)

    const userGroups = [
      { header: 'キャスト', key: 'cast' },
      { header: 'スタッフ', key: 'waiter' },
      { header: 'アライアンス', key: 'alliance' },
    ]

    const items = computed(() => {
      return props.aggregationUsers.map(au => au.user.data.attributes)
    })

    const handleUserChange = (event: UserAttrs | null) => {
      if (!event && displayModeModel.value === 'daily') {
        displayModeModel.value = 'sum'
      }
    }

    return {
      displayModeModel,
      selectedUserIdModel,
      selectedUser,
      isUserAggregation,
      userGroups,
      items,
      handleUserChange,
    }
  },
})
